import React from 'react';
import { ClipboardCopy } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';

export const buildIntegrationInstructions = (baseUrl) => `INSTRUCCIONES PARA EL SISTEMA EMISOR DE ACTAS (integración con MacroPago)

Base URL: ${baseUrl}/api/v1
Autenticación: header "X-API-Key: <api key de MacroPago>"
Documentación interactiva: ${baseUrl}/api/docs

1) Alta/actualización de un acta (crea o actualiza el acta por número):
POST ${baseUrl}/api/v1/actas
Content-Type: application/json
{
  "plate": "AB123CD",
  "acta_number": "T-129304",
  "infraccion": "Cruce de semáforo en rojo",
  "fecha": "2026-05-10",
  "hora": "14:32",
  "lugar": "Av. Alem y San Martín",
  "monto": 350000,
  "monto_quita": 210000,
  "discount_expiry": "2026-07-31",
  "titular": {
    "name": "Juan Pérez",
    "dni": "30111222",
    "cuit": "20-30111222-5",
    "address": "Calle 123", "city": "Tafí Viejo", "province": "Tucumán",
    "phone": "381 555 1234",
    "email": "juan@mail.com",
    "phones": ["381 444 5555", {"value": "381 666 7777", "label": "Laboral"}],
    "emails": [{"value": "juan.perez@trabajo.com", "label": "Laboral"}]
  }
}

Teléfonos y emails:
- "phone" y "email": contacto principal del titular.
- "phones" y "emails": listas de contactos adicionales. Cada ítem puede ser un string o {"value": "...", "label": "Titular|Familiar|Laboral|Garante|Otro"}.
- MacroPago SUMA los contactos nuevos a la ficha del titular sin borrar ni pisar los existentes, y descarta duplicados (mismo número con distinto formato) e inválidos.
- Si el acta ya existe, se actualizan sus datos y se suman los contactos nuevos.

2) Carga masiva (hasta 500 actas por llamada):
POST ${baseUrl}/api/v1/actas/batch
{ "actas": [ { ...misma estructura que arriba... }, ... ] }

3) Archivos del acta (PDF y video MP4/WEBM/MOV, hasta ~2 MB el video):
POST ${baseUrl}/api/v1/actas/{acta_number}/archivos  (multipart/form-data: campos "pdf" y/o "video")

4) Consulta:
GET ${baseUrl}/api/v1/actas/{acta_number}

Respuestas: 200 OK con {"acta": ..., "debtor_id": ..., "created_debtor": bool}; 400 con "detail" en español si falta un dato; 401 si la API key es inválida.
`;

export const CopyIntegrationInstructions = () => {
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(buildIntegrationInstructions(window.location.origin));
      toast.success('Instrucciones copiadas. Pegalas en el chat del sistema emisor (Centinela Vial).');
    } catch { toast.error('No se pudo copiar al portapapeles'); }
  };
  return (
    <Button variant="outline" size="sm" onClick={copy} className="shrink-0" data-testid="copy-integration-instructions-btn">
      <ClipboardCopy className="w-4 h-4 mr-2" />Copiar instrucciones para el sistema emisor
    </Button>
  );
};
